import httpClient from './httpClient';

export default {
  getQuestions: user => httpClient.post('/api/credit/get-questions', user),
  answerQuestions: user => httpClient.post('/api/credit/answer-questions?decrypt=1', user),
  prequalify700: user => httpClient.post('/api/700credit/prequalify/report', user),
  prequalify700Equifax: user => httpClient.post('/api/700credit/prequalify/equifax-questions', user),
  prequalify700EquifaxAnswered: user => httpClient.post('/api/700credit/prequalify/equifax-questions-answered', user),
  prequalify700WithPin: user => httpClient.post('/api/700credit/prequalify/report-with-access-pin', user),
  getRegionalCreditScore: postalCode => httpClient.get(`/api/credit/regional-score/${postalCode}`),
  calculatePrequalifications: (apiKey, externalId, creditScorePayload) =>
    httpClient.post(`/api/credit/calculatePrequalifications/${apiKey}/${externalId}`, creditScorePayload),
  getConsumerInventoryMatch: leadId => httpClient.get(`/api/credit/consumer-inventory-match/lead/${leadId}`),
  getTradeLines: leadId => httpClient.get(`/api/lead/${leadId}/tradeLines?decrypt=1`),
};
